import React,{useState} from 'react';
import Header from './components/Header';
import {css} from 'emotion';
import MenuAccount from './components/menu-account';
import Menu from './components/menu';
import MenuMobile from './components/menu-mobile';

import Media from 'react-media';


const Layout = (props) =>{



  const [showMenu,setShowMenu] = useState(false);

  const openMenuAccount = () =>{
      setShowMenu(!showMenu);
  }

  const hideMenuAccount = (e) =>{
    setShowMenu(false)
  }




  return(
    <div className={css`width:100vw;min-height:100vh;background:#f5f5f5`}>
      <Header openMenuAccount={openMenuAccount}/>
      <Media query="(max-width: 678px)">
      {matches =>
        matches?   (
             <MenuMobile location={props.location}/>
           ): (
            <Menu location={props.location}/>
           )
         }
       </Media>

      <div className={css`padding-top:60px`}>
        <div className={css`width:calc(100% - 80px);margin-top:10px;padding-top:0px;box-sizing:border-box;margin-left:70px;padding-bottom:20px;
          @media (max-width: 678px) {
                margin-left:0px;
                width:100%;
                padding-left:20px;
                padding-right:20px;
                box-sizing:border-box;
                padding-bottom:70px;
              }
          `}>
      {props.children}
        </div>
      </div>
      {showMenu && <MenuAccount hideMenuAccount={hideMenuAccount}/>}
    </div>
  )
}
export default Layout;
